/**
 * Whether the "Change type" action should be visible for a team.
 * Extracted for unit testing; used by useTeamActions.
 * Visibility is self-contained (checks enableChangeTeamTypeFlag here) so callers need not pre-filter.
 */
export const isChangeTeamTypeActionVisible = ({
  enableChangeTeamTypeFlag,
  changeTeamTypeEnabled,
  hideModifyingActions,
  hideSupplyActions,
  hasTeamType,
}) =>
  Boolean(
    enableChangeTeamTypeFlag &&
    changeTeamTypeEnabled &&
    !hideModifyingActions &&
    !hideSupplyActions &&
    hasTeamType
  );
